import styled from 'styled-components';
import { FONTS, COLORS, SIZE, FONT_SIZE } from '@app/src/ui';

interface Props {
  error?: boolean;
}

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: ${FONT_SIZE.SHORT};
  padding: 5px 15px;

  ${(props: Props) => props.error ? `
    background: ${COLORS.RED_ERROR};
    color: #fff;
  ` : `
    background: ${COLORS.YELLOW};
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: ${SIZE.LARGE_DESKTOP};
  margin: 0 auto;
  min-height: 44px;

`;

export const IconWrapper = styled.span`
  margin: 2px 0 0 auto;
  cursor: pointer;
`;
